import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SprayCanIcon, MapPinnedIcon, HeartIcon, ClipboardCheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: SprayCanIcon,
    title: 'Limpieza Enzimática Real',
    description: 'Borrar la "memoria química" del mueble (no solo el olor para humanos).'
  }, {
    icon: MapPinnedIcon,
    title: 'Logística N+1',
    description: 'El mapa exacto de dónde poner las bandejas para que el gato no tenga excusas.'
  }, {
    icon: HeartIcon,
    title: 'Señales de Paz',
    description: 'Re-mapear tu hogar para que el gato sienta seguridad, no amenaza.'
  }];
  return <section className="w-full bg-[#FAFAF7] py-10 md:py-20 px-6" data-id="element-454">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto" data-id="element-455">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-12 text-center" data-id="element-456">
          Con el Protocolo de 72 Horas, vamos a trabajar en 3 frentes
          simultáneos que nadie te explicó antes:
        </h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-457">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-458">
                <Icon className="w-10 h-10 text-[#2D8C5A] mb-4" data-id="element-459" />
                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#1C1C1C] mb-2" data-id="element-460">
                  {item.title}
                </h3>
                <p className="text-[#1C1C1C]/70 leading-relaxed" data-id="element-461">
                  {item.description}
                </p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}